import { render } from "./AddDemandePrix.vue?vue&type=template&id=5117f633&scoped=true&ts=true"
import script from "./AddDemandePrix.vue?vue&type=script&lang=ts"
export * from "./AddDemandePrix.vue?vue&type=script&lang=ts"

import "./AddDemandePrix.vue?vue&type=style&index=0&id=5117f633&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5117f633"]])

export default __exports__